import { render, staticRenderFns } from "./SectionAdsBlock.vue?vue&type=template&id=3dd6fec7&scoped=true&"
import script from "./SectionAdsBlock.vue?vue&type=script&lang=js&"
export * from "./SectionAdsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SectionAdsBlock.vue?vue&type=style&index=0&id=3dd6fec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6fec7",
  null
  
)

export default component.exports